<div class="assign_to_carrier">
  <div class="header margin-auto">
    <h1>Assign batch for delivery</h1>

    <pdq-button
      style="position: absolute; right: 16px"
      iconColor="var(--on-surface-light)"
      (onClick)="dialogRef.close({ saveSelectedOrders: true })"
      variant="ghost"
      icon="close"></pdq-button>
  </div>

  @if (enableAddToBatch) {
  <div class="tabs-container">
    <pdq-tabs-group (onChange)="onSelectedTabChanged($event)">
      <pdq-tab value="carriers" label="Assign to carrier"></pdq-tab>
      <pdq-tab value="batches" label="Add to existing batch"></pdq-tab>
    </pdq-tabs-group>
    @if (activeTab === 'batches') { @if (usePaginatedAddToBatch()) {
    <div class="batches paginated">
      <add-to-batches-table
        [selectedOrders]="data.selected"
        [shop]="shop"
        [carriers]="carriers"
        (batchSelected)="addToBatch($event)"
        [selectedBatchId]="selectedBatchId"
        (loadingChange)="loadingBatches = $event">
      </add-to-batches-table>
    </div>
    } @else { @if (loadingBatches) {
    <div class="margin-auto">
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
    } @else {
    <div class="batches">
      <div class="batches-title">
        <h3>Fulfillment ready</h3>
        <filter-batches
          [batches]="batches"
          (filteredBatchesChanged)="onFilteredBatchesChanged($event)"></filter-batches>
      </div>
      @if (filteredBatches) {
      <div class="columns">
        @for (column of columns; track column) {
        <div class="column">{{ column }}</div>
        }
      </div>
      }
      <div class="batches-container">
        @for (batch of filteredBatches; track batch) {
        <div class="batch-row-container">
          <batch-list-table-row class="batch-list-table-row" [batch]="batch"></batch-list-table-row>
          <pdq-button
            class="batch-assign-button"
            [disabled]="batch.mismatchError || loadingSmartBatch || loadingBestBatch"
            [matTooltip]="batch.mismatchError"
            matTooltipClass="pdq-mat-tooltip"
            [loading]="loadingSmartBatch && selectedBatchId == batch.id"
            size="medium"
            label="Add to this batch"
            variant="primary"
            (onClick)="addToBatch(batch)">
          </pdq-button>
        </div>
        }
      </div>
    </div>
    } } } @else { @if (loadingCarriers) {
    <div class="margin-auto">
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
    } @else {
    <div class="content margin-auto">
      @if (enableBestMatch) {
      <div class="best-match-card margin-auto">
        <span class="carrier-logo">
          <carrier-logo carrierName="pdq"></carrier-logo>
        </span>
        <span class="name margin-auto">PDQ best match</span>
        <span class="breathing-text margin-auto">
          @if (loadingBestBatch) {
          <span> {{ bestMatchCalculationText }} </span>
          }
        </span>
        <span class="actions margin-auto">
          <pdq-button
            [disabled]="loadingBestBatch || loadingSmartBatch"
            [loading]="loadingBestBatch"
            size="medium"
            label="Get best rates"
            variant="tertiary"
            (onClick)="openBestMatch()">
          </pdq-button>
        </span>
      </div>
      }
      <div class="delivery-services-header margin-auto">
        <pdq-icon
          class="sort-icon"
          (click)="changeDeliveryServicesSort()"
          [icon]="'sort_'+sortIcon"
          size="medium"
          [paths]="2">
        </pdq-icon>
        <span class="text">Delivery service</span>
      </div>
      <div class="carriers-list margin-auto">
        @for (row of rows; track row) {
        <div class="carrier-card">
          <span class="carrier-logo">
            <carrier-logo [carrierName]="row.type?.name"></carrier-logo>
          </span>
          <span class="name margin-auto"> {{ row.name }}</span>
          @if (row.isTestMode) {
          <pdq-tag class="margin-auto" variant="quaternary" size="small">Test mode</pdq-tag>
          }
          <span class="breathing-text margin-auto">
            @if (loadingSmartBatch && selectedCarrierId == row.id) {
            <span> {{ ratesCalculationInfoText }} </span>
            }
          </span>
          <span class="actions margin-auto">
            <pdq-button
              [disabled]="row.disabled || loadingSmartBatch || loadingBestBatch"
              [loading]="loadingSmartBatch && selectedCarrierId == row.id"
              size="medium"
              label="Assign delivery"
              variant="primary"
              (onClick)="assignToCarrier(row)">
            </pdq-button>
          </span>
        </div>
        }
      </div>
    </div>
    } }
  </div>
  } @else {
  <div class="divider"></div>
  <ng-container *ngTemplateOutlet="carriersTemplate"></ng-container>
  }

  <ng-template #carriersTemplate>
    @if (loadingCarriers) {
    <div class="margin-auto">
      <app-main-loader-lottie> </app-main-loader-lottie>
    </div>
    } @else {
    <div class="content margin-auto">
      @if (enableBestMatch) {
      <div class="best-match-card margin-auto">
        <span class="carrier-logo">
          <carrier-logo carrierName="pdq"></carrier-logo>
        </span>
        <span class="name margin-auto">PDQ best match</span>
        <span class="breathing-text margin-auto">
          @if (loadingBestBatch) {
          <span> {{ bestMatchCalculationText }} </span>
          }
        </span>
        <span class="actions margin-auto">
          <pdq-button
            [disabled]="loadingBestBatch || loadingSmartBatch"
            [loading]="loadingBestBatch"
            size="medium"
            label="Get best rates"
            variant="tertiary"
            (onClick)="openBestMatch()">
          </pdq-button>
        </span>
      </div>
      }
      <div class="delivery-services-header margin-auto">
        <pdq-icon
          class="sort-icon"
          (click)="changeDeliveryServicesSort()"
          [icon]="'sort_'+sortIcon"
          size="medium"
          [paths]="2">
        </pdq-icon>
        <span class="text">Delivery service</span>
      </div>
      <div class="carriers-list margin-auto">
        @for (row of rows; track row) {
        <div class="carrier-card">
          <span class="carrier-logo">
            <carrier-logo [carrierName]="row.type?.name"></carrier-logo>
          </span>
          <span class="name margin-auto"> {{ row.name }}</span>
          @if (row.isTestMode) {
          <pdq-tag class="margin-auto" variant="quaternary" size="small">Test mode</pdq-tag>
          }
          <span class="breathing-text margin-auto">
            @if (loadingSmartBatch && selectedCarrierId == row.id) {
            <span> {{ ratesCalculationInfoText }} </span>
            }
          </span>
          <span class="actions margin-auto">
            <pdq-button
              [disabled]="row.disabled || loadingSmartBatch || loadingBestBatch"
              [loading]="loadingSmartBatch && selectedCarrierId == row.id"
              size="medium"
              label="Assign delivery"
              variant="primary"
              (onClick)="assignToCarrier(row)">
            </pdq-button>
          </span>
        </div>
        }
      </div>
    </div>
    }
  </ng-template>
</div>
